import React, { PropTypes } from 'react';
import Modal from '../../Modal';
import Form, { FormBody, FormActions, TextInput, SelectInput, DateInput } from '../../Form';
import { inject, observer } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import moment from 'moment';
import { token } from "../../../libs/localStorage";

@inject('ticketStore', 'stationStore', 'userStore', 'ticketStatusStore', 'ticketReasonStore', 'ticketActionStore', 'rolePermissionStore')
@observer
export default class TicketAdd extends React.Component {

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = this.props.slug ? '/' + this.props.slug : '/monitoring/ticket/tabular';

  @observable item = {
    status_id: null,
    reason_id: null,
    action_id: null,
    user_id: +token.getDecoded().id,
    summary: '',
    description: '',
    station_id: this.props.station_id || null,
    assigned_to: null,
    end_date: null,
    name: '',
    mobile_no: '',
    email_address: '',
  };

  @action onChangeStation = e => this.item.station_id = +e.target.value;
  @action onChangeSummary = e => { if (e.target.value.length < 50) this.item.summary = e.target.value; };
  @action onChangeDescription = e => this.item.description = e.target.value;
  @action onChangeAssignedTo = e => this.item.assigned_to = +e.target.value;
  @action onChangeStatus = e => this.item.status_id = +e.target.value;
  @action onChangeReason = e => this.item.reason_id = +e.target.value;
  @action onChangeAction = e => this.item.action_id = +e.target.value;
  @action onChangeName = e => this.item.name = e.target.value;
  @action onChangeMobileNo = e => this.item.mobile_no = e.target.value;
  @action onChangeEmail = e => this.item.email_address = e.target.value;

  handleSave = e => {
    e.preventDefault();
    const { ticketStore, userStore, stationStore, rolePermissionStore } = this.props;
    const { notify, router } = this.context;
    const hasUserPermission = rolePermissionStore.validateRole('view user');

    if (!this.item.status_id || !this.item.reason_id || !this.item.action_id || !this.item.summary || !this.item.station_id || (!hasUserPermission ? false : !this.item.assigned_to)) {
      notify.error({ message: 'missing fields' });
      return;
    }

    const sender = token.getDecoded();
    const follower = userStore.findById(this.item.assigned_to);
    const station = stationStore.findById(this.item.station_id).asJson;

    ticketStore.createItem({
      ...this.item,
      sender: {
        name: sender.name,
        email: sender.email
      },
      follower: !!follower ? follower.email : null,
      station_name: station.name,
      origin: window.location.origin
    }).then((res) => {
      notify.success({ message: 'Ticket Created' });
      if (res.mail) notify.success({ message: 'Email sent' });
      else notify.error({ message: 'Email not sent' });
      ticketStore.fetchItem(res.id, true)
      router.push(this.slug);
    }).catch(err => {
      notify.error({ message: err.message });
      console.log(err)
    });
  };

  render() {
    const { stationStore, userStore, ticketStatusStore, ticketReasonStore, ticketActionStore, ticketStore, rolePermissionStore } = this.props;
    const station = stationStore.findById(this.item.station_id);
    const hasUserPermission = rolePermissionStore.validateRole('view user');

    return (
      <Modal slug={this.slug} title='Add Ticket' isSaving={ticketStore.isSaving}>
        <Form>
          <FormBody>
            <SelectInput
              id={'Status'}
              label={'Status *'}
              value={this.item.status_id}
              options={ticketStatusStore.items}
              onChange={this.onChangeStatus}
              fields={{
                label: 'caption',
                value: 'id',
              }}
            />

            <SelectInput
              id={'Reason'}
              label={'Reason *'}
              value={this.item.reason_id}
              options={ticketReasonStore.items}
              onChange={this.onChangeReason}
              fields={{
                label: 'caption',
                value: 'id',
              }}
            />

            <SelectInput
              id={'Action'}
              label={'Action *'}
              value={this.item.action_id}
              options={ticketActionStore.items}
              onChange={this.onChangeAction}
              fields={{
                label: 'caption',
                value: 'id',
              }}
            />

            <TextInput label={`Summary *`} value={this.item.summary} onChange={this.onChangeSummary} />
            <TextInput label='Description' value={this.item.description} onChange={this.onChangeDescription} />

            {!this.props.station_id ? <SelectInput
              id={'Station'}
              label={'Station *'}
              value={this.item.station_id}
              options={stationStore.items}
              onChange={this.onChangeStation}
              fields={{
                label: 'name',
                value: 'id',
              }}
            /> : <TextInput label={'Station'} value={!!station ? station.name : ''} readOnly />}

            {hasUserPermission && <SelectInput
              id={'Assigned To'}
              label={'Assigned To *'}
              value={this.item.assigned_to}
              options={userStore.items}
              onChange={this.onChangeAssignedTo}
              fields={{
                label: 'name',
                value: 'id',
              }}
            />}

            <TextInput label='Name' value={this.item.name} onChange={this.onChangeName} />
            <TextInput label='Mobile No.' value={this.item.mobile_no} onChange={this.onChangeMobileNo} />
            <TextInput label='Email Address' value={this.item.email_address} onChange={this.onChangeEmail} />


          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/TicketAdd.js